'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/type.js
// module id = 163
// module chunks = 0